import { autoinject } from 'aurelia-framework';
import { NumeralConverter } from '../services/numeral-converter';

@autoinject
export class NumericFormatterValueConverter {
  constructor(private numeralConverter: NumeralConverter) { }

  toView(value: number, format: string | number) {
    if (format === undefined || format === null || format === '' || !value) {
      return value;
    }

    return this.numeralConverter.format(value, format);
  }

  fromView(value: string) {
    return this.numeralConverter.parse(value);
  }
}

